import "./Banner.scss";

export default function Banner(props) {
  return (
    <div className="banner-content">
      <div className="img-content ">
        <img className="img-content " src={props.imgSrc} alt="img"></img>
        <h1 className={`press-text${" "}${props.widthStyle}`}>{props.title}</h1>
        <p className={`details-text${" "}${props.widthStyle}`}>
          {props.details}
        </p>
      </div>
    </div>
  );
}
